import { SFCCSharedBasket } from '../../models/sfcc-shared-basket';
import { shopHttp } from '../basket-api';

export const getBasketFromUrl = async (customObjectKey: string): Promise<SFCCSharedBasket> => {
  const url = `/custom_objects/SharedBasket/${customObjectKey}`;
  const response = await shopHttp.get<SFCCSharedBasket>(url);

  return response.data;
};
